import { Component, OnInit } from '@angular/core';
import { AppServerAPI, DataType, DialogService, PagedContentConfiguration, PagedContentType, TableColumnDefinition } from '@sdbn/common';
import { EquipmentType } from '../../common/equipment.model';

@Component({
  selector: 'app-equipment-admin',
  templateUrl: './equipment-admin.component.html',
  styleUrls: ['./equipment-admin.component.scss']
})
export class EquipmentAdminComponent implements OnInit {


  data = [];

  configuration = new PagedContentConfiguration({
    columns: [
      new TableColumnDefinition({
        dictionaryKey: 'key',
        type: DataType.STRING,
        identifier: 'key'
      }),
      new TableColumnDefinition({
        dictionaryKey: 'type',
        type: DataType.STRING,
        identifier: 'type'
      })
    ],
    itemDataAccessor: {
      getTitle: (item: any) => item['name'],
      getSubtitle: (item: any) => null,
      getIcon: (item: any) => 'fa-people'
    },
    desktopType: PagedContentType.SIDE_TAB_SINGLE,
    mobileType: PagedContentType.ICON_MENU_SINGLE
  });

  currentSelectedListEntry: EquipmentType;
  currentEquipmentType: EquipmentType;

  constructor(
    private appServerAPI: AppServerAPI,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.loadAll();
  }

  public onAddRequested() {
    this.currentEquipmentType = new EquipmentType();
    this.currentSelectedListEntry = null;
  }

  onDeleteRequested(item: any) {
    let equipment = item as EquipmentType;
    this.dialogService.showConfirm('', '').afterClosed().subscribe(result => {
      if (result) {
        this.appServerAPI.execute('/tmc-common/equipment/delete', equipment).subscribe(response => {
          if (response) {
            this.loadAll();
          }
        });
      }
    });
  }

  private loadAll() {
    this.appServerAPI.execute<EquipmentType[]>('/tmc-common/equipment/getAll', null).subscribe(response => {
      if (response) {
        let data = new Array<EquipmentType>();
        for (let type of response) {
          data.push(new EquipmentType(type));
        }
        this.data = data;
      }
    });
  }

  public onChanged() {
    this.loadAll();
  }

  public onSelectionChanged(selected: any) {
    this.currentSelectedListEntry = selected as EquipmentType;
    if (selected != null) {
      this.appServerAPI.execute<EquipmentType>('/tmc-common/equipment/getEquipmentType', this.currentSelectedListEntry.id).subscribe(response => {
        if (response) {
          this.currentEquipmentType = new EquipmentType(response);
        }
      });
    } else {
      this.currentEquipmentType = null;
    }
  }

  public onCancel() {
    if (this.currentSelectedListEntry == null) {
      if (this.data.length > 0) {
        this.onSelectionChanged(this.data[0]);
      } else {
        this.onSelectionChanged(null);
      }
    } else {
      this.onSelectionChanged(this.currentSelectedListEntry);
    }
  }

}
